import React from "react";
import { NavLink } from "react-router-dom";
import OpenText from "../../OpenText";
import {
  Gift,
  Truck,
  PackageCheck,
  CircleDollarSign,
  Bot,
  ArrowLeft,
  Phone,
  ShoppingBasket,
} from "lucide-react";

const FEATURES = [
  {
    icon: Bot,
    title: "טכנולוגיה חכמה",
    desc: "רובוטים ומלאי מדויק — מה שבמלאי, זה מה שמגיע",
  },
  {
    icon: Truck,
    title: "משלוח מהיר",
    desc: "הספקה תוך שעות ספורות עד הבית",
  },
  {
    icon: PackageCheck,
    title: "מגוון רחב",
    desc: "אלפי מוצרי מזון, ניקיון וצרכנות — הכל במקום אחד",
  },
  {
    icon: CircleDollarSign,
    title: "מחירים הוגנים",
    desc: "ניהול יעיל שחוסך עלויות — ומועבר אליך",
  },
];

const Home = () => {
  return (
    <div className="home-page">
      <section className="home-hero" aria-labelledby="home-hero-title">
        <div className="home-hero__bg" aria-hidden />
        <div className="hz-container home-hero__inner">
          <div className="home-hero__content">
            <span className="home-hero__badge">
              <ShoppingBasket size={16} strokeWidth={2} aria-hidden />
              קניות אונליין חכמות
            </span>
            <h1 id="home-hero-title" className="home-hero__title">
              ברוכים הבאים
              <br />
              <span className="home-hero__title-accent">להמזון אונליין</span>
            </h1>
            <p className="home-hero__subtitle">
              הזמינו מוצרי מזון וצרכנות ישירות מהמרלוג השכונתי — מלאי מדויק,
              משלוח מהיר ומחירים הוגנים.
            </p>
            <div className="home-hero__actions">
              <NavLink to="/category/1" className="home-btn home-btn--primary">
                התחילו לקנות
                <ArrowLeft size={18} strokeWidth={2} aria-hidden />
              </NavLink>
              <NavLink to="/sales" className="home-btn home-btn--sale">
                <Gift size={18} strokeWidth={2} aria-hidden />
                מבצעים
              </NavLink>
            </div>
          </div>
          <div className="home-hero__stats" aria-label="יתרונות השירות">
            <div className="home-hero__stat">
              <span className="home-hero__stat-value">3 שעות</span>
              <span className="home-hero__stat-label">זמן משלוח ממוצע</span>
            </div>
            <div className="home-hero__stat">
              <span className="home-hero__stat-value">100%</span>
              <span className="home-hero__stat-label">מלאי מדויק</span>
            </div>
            <div className="home-hero__stat">
              <span className="home-hero__stat-value">24/7</span>
              <span className="home-hero__stat-label">הזמנה בכל שעה</span>
            </div>
          </div>
        </div>
      </section>

      <section
        className="home-section home-features"
        aria-labelledby="home-features-title"
      >
        <div className="hz-container">
          <div className="home-section__header">
            <h2 id="home-features-title" className="home-section__title">
              למה להזמין אצלנו?
            </h2>
            <p className="home-section__subtitle">
              חוויית קנייה חדשנית שחוסכת זמן וכסף
            </p>
          </div>
          <div className="home-features__grid">
            {FEATURES.map(({ icon: Icon, title, desc }) => (
              <article key={title} className="home-feature-card">
                <span className="home-feature-card__icon" aria-hidden>
                  <Icon size={26} strokeWidth={1.65} />
                </span>
                <h3 className="home-feature-card__title">{title}</h3>
                <p className="home-feature-card__desc">{desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="home-section home-announcements">
        <div className="hz-container">
          <OpenText ShowHome />
        </div>
      </section>

      <section className="home-cta" aria-labelledby="home-cta-title">
        <div className="hz-container home-cta__inner">
          <div className="home-cta__content">
            <h2 id="home-cta-title" className="home-cta__title">
              צריכים עזרה?
            </h2>
            <p className="home-cta__text">
              צוות שירות הלקוחות שלנו כאן בשבילכם
            </p>
          </div>
          <NavLink to="/contacts" className="home-btn home-btn--outline">
            <Phone size={18} strokeWidth={2} aria-hidden />
            צרו קשר
          </NavLink>
        </div>
      </section>
    </div>
  );
};

export default Home;
